import { createSlice } from '@reduxjs/toolkit';

export const signIn = createSlice({
    name: 'signIn',

    initialState: {
        isSignedIn: false
    },

    reducers: {
        setIsSignedIn: (state, action) => {
            state.isSignedIn = action.payload;
        }
    }
});

export const { setIsSignedIn } = signIn.actions;

export default signIn.reducer;
